import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SeverityBadge } from "@/components/Primitives";

export default function CustomerRisk() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/risk/customers").then(r => setItems(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Customer Risk Intelligence</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Risk Score &amp; Renewal Risk</h1>
        <p className="text-sm text-zinc-500 mt-1">Composite score across critical tickets, recurring issues, SLA breaches, compliance, security, identity, backups, and contracts.</p>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-[10px] uppercase tracking-widest text-zinc-500 font-mono"><tr><th className="text-left px-4 py-3">Client</th><th className="text-left px-4 py-3">Score</th><th className="text-left px-4 py-3">Level</th><th className="text-left px-4 py-3">Critical Tkts</th><th className="text-left px-4 py-3">Recurring</th><th className="text-left px-4 py-3">SLA Breach</th><th className="text-left px-4 py-3">Compliance</th><th className="text-left px-4 py-3">Security</th><th className="text-left px-4 py-3">Renewal Risk</th></tr></thead>
          <tbody>
            {items.map(c => (
              <tr key={c.client_id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2">{c.client_name}</td>
                <td className="px-4 py-2 font-mono text-zinc-200">{c.risk_score}</td>
                <td className="px-4 py-2"><SeverityBadge level={c.risk_level}/></td>
                <td className="px-4 py-2 font-mono text-xs">{c.factors.critical_tickets}</td>
                <td className="px-4 py-2 font-mono text-xs">{c.factors.recurring_issues}</td>
                <td className="px-4 py-2 font-mono text-xs">{c.factors.sla_breaches}</td>
                <td className="px-4 py-2 font-mono text-xs">{c.factors.compliance_findings}</td>
                <td className="px-4 py-2 font-mono text-xs">{c.factors.security_findings}</td>
                <td className="px-4 py-2"><SeverityBadge level={c.renewal_risk}/></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
